export default __webpack_public_path__ + "99b0a403b4ac5f06359fcf342ccf4d7d.png";